export const FILE_MANAGER_ERROR_STATUSES = ['ERROR', 'IMAGE_LIMIT_EXCEEDED'] as const;

export type FileManagerErrorStatus = typeof FILE_MANAGER_ERROR_STATUSES[number];

export function isFileManagerErrorStatus(status?: string): status is FileManagerErrorStatus {
  return !!status && (FILE_MANAGER_ERROR_STATUSES as readonly string[]).includes(status);
}
